module.exports = __webpack_public_path__ + "img/gl.fe3c0b10.png";